module.exports = __webpack_public_path__ + "static/media/mindfulness-for-sleep@3x.a43562a4.png";